import React from "react";
const useElementId = (id) => {
    const generatedId = React.useId();
    if (id)
        return id;
    return generatedId;
};
export default useElementId;
